export default __webpack_public_path__ + "static/media/FoodChainOcean_01.9cff780e.png";